
import React, { useEffect, useMemo, useState } from "react";
import { FiSave } from "react-icons/fi";

import {
  saveDailySettlement,
} from "./RepresentativeSettlementService";

const PaymentMethods = ({
  selectedRepresentative,
  dailyData,
  date,
  onSaved,
}) => {
  const [cashAmount, setCashAmount] = useState(0);
  const [instaPayAmount, setInstaPayAmount] = useState(0);
  const [vodafoneCashAmount, setVodafoneCashAmount] =
    useState(0);

  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setCashAmount(
      Number(dailyData?.cashAmount || 0)
    );

    setInstaPayAmount(
      Number(dailyData?.instaPayAmount || 0)
    );

    setVodafoneCashAmount(
      Number(dailyData?.vodafoneCashAmount || 0)
    );

    setNotes(dailyData?.notes || "");
  }, [dailyData]);

  /* ================================
     المستحق السابق
  ================================= */

  const previousDue = Number(
    dailyData?.previousDue || 0
  );

  /* ================================
     إجمالي المستحق
  ================================= */

  const totalDue = Number(
    dailyData?.totalDue ??
      dailyData?.currentRemaining ??
      0
  );

  /* ================================
     المسدد
  ================================= */

  const paidAmount = useMemo(() => {
    return (
      Number(cashAmount || 0) +
      Number(instaPayAmount || 0) +
      Number(vodafoneCashAmount || 0)
    );
  }, [
    cashAmount,
    instaPayAmount,
    vodafoneCashAmount,
  ]);

  /* ================================
     المتبقي
  ================================= */

  const remainingAmount = Math.max(
    totalDue - paidAmount,
    0
  );

  const formatNumber = (value) => {
    return Number(value || 0).toLocaleString("ar-EG");
  };

  /* ================================
     حفظ التسوية
  ================================= */

  const handleSaveSettlement = async () => {
    if (!selectedRepresentative?.id) {
      return;
    }

    try {
      setSaving(true);

      await saveDailySettlement({
        representativeId:
          selectedRepresentative.id,

        dailyDate: `${date}T00:00:00`,

        cashAmount:
          Number(cashAmount) || 0,

        instaPayAmount:
          Number(instaPayAmount) || 0,

        vodafoneCashAmount:
          Number(vodafoneCashAmount) || 0,

        notes: notes || "",
      });

      if (onSaved) {
        onSaved();
      }

    } catch (error) {
      console.error(
        "save settlement error:",
        error
      );
    } finally {
      setSaving(false);
    }
  };

  if (!selectedRepresentative || !dailyData) {
    return null;
  }

return (
  <section className="settlement-section">

    <h3 className="settlement-title">
      تسوية المندوب
    </h3>

    <div className="settlement-rows">

      <div className="settlement-row">
        <div className="settlement-label">
          المستحق /
        </div>

        <div className="settlement-value">
          {formatNumber(previousDue)}
        </div>
      </div>

      <div className="settlement-row">
        <div className="settlement-label">
          النقدي /
        </div>

        <div className="settlement-value">
          <input
            type="number"
            min="0"
            value={cashAmount}
            onChange={(event) =>
              setCashAmount(event.target.value)
            }
            className="settlement-input"
          />
        </div>
      </div>

      <div className="settlement-row">
        <div className="settlement-label">
          InstaPay /
        </div>

        <div className="settlement-value">
          <input
            type="number"
            min="0"
            value={instaPayAmount}
            onChange={(event) =>
              setInstaPayAmount(event.target.value)
            }
            className="settlement-input"
          />
        </div>
      </div>

      <div className="settlement-row">
        <div className="settlement-label">
          Vodafone Cash /
        </div>

        <div className="settlement-value">
          <input
            type="number"
            min="0"
            value={vodafoneCashAmount}
            onChange={(event) =>
              setVodafoneCashAmount(event.target.value)
            }
            className="settlement-input"
          />
        </div>
      </div>

      <div className="settlement-row">
        <div className="settlement-label">
          المسدد /
        </div>

        <div className="settlement-value">
          {formatNumber(paidAmount)}
        </div>
      </div>

     <div className="settlement-row">
        <div className="settlement-label">
          إجمالي المستحق /
        </div>

        <div
          className={`settlement-value ${
            totalDue < 0
              ? "settlement-credit"
              : totalDue > 0
              ? "settlement-debit"
              : ""
          }`}
        >
          {totalDue < 0
            ? `للمندوب / ${formatNumber(Math.abs(totalDue))}`
            : totalDue > 0
            ? `عليه / ${formatNumber(totalDue)}`
            : "0"}
        </div>
      </div>

      {/* <div className="settlement-row">
        <div className="settlement-label">
          المتبقي /
        </div>

        <div className="settlement-value settlement-remaining">
          {formatNumber(remainingAmount)}
        </div>
      </div> */}

    </div>

    <div className="settlement-notes">

      <label>
        ملاحظات
      </label>

      <textarea
        value={notes}
        onChange={(event) =>
          setNotes(event.target.value)
        }
        placeholder="اكتب ملاحظات التسوية..."
      />

    </div>

    {/* =========================
        SAVE SETTLEMENT
    ========================== */}

    <div
      className="save-settlement-force"
      onClick={() => {
        if (!saving) {
          handleSaveSettlement();
        }
      }}
    >
      <FiSave size={16} />

      <span>
        {saving
          ? "جاري الحفظ..."
          : "حفظ التسوية"}
      </span>
    </div>

  </section>
);
};

export default PaymentMethods;
